const _isBrowser = typeof window !== 'undefined';

function isBrowser() {
  return _isBrowser;
}

exports.isBrowser = isBrowser;